import { createSelector } from '@reduxjs/toolkit';
import selfSelector from './self';

const errorSelector = createSelector(selfSelector, (rejectsReport) => rejectsReport.error);

export default errorSelector;
